import { useModalCountdown } from "../hooks/useModalCountdown";

export const ShowModal = () => {
  useModalCountdown();

  return null;
};
